if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target)
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia?.classList?.add("is-active");

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

// document.addEventListener('DOMContentLoaded', function() {
//   const sectionId = '{{ section.id }}';
//   const sliderId = `Slider-Gallery-${sectionId}`;
//   const slider = document.getElementById(sliderId);
//   const mediaId = '{{ featured_media.id }}';
//   const itemId = `Slide-${sectionId}-${mediaId}`;
//   const items = document.getElementById(itemId);
//   let currentIndex = 0;
//   let lastScrollTop = 0;

//   function updateSlider(index) {
//     const yOffset = 599; // Adjust the Y offset value based on your requirements
//     const newY = -(index * yOffset);
//     slider.style.transform = `translate3d(0px, ${newY}px, 0px)`;
//     slider.style.pointerEvents = 'auto';
//     slider.style.width = '399.333px';
//   }

//   // Initial update
//   updateSlider(currentIndex);

//   // Scroll event listener
//   document.addEventListener('scroll', function() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//     if (scrollTop > lastScrollTop) {
//       // Scrolling down
//       if (currentIndex < items.length - 1) {
//         currentIndex++;
//         updateSlider(currentIndex);
//       }
//     } else {
//       // Scrolling up
//       if (currentIndex > 0) {
//         currentIndex--;
//         updateSlider(currentIndex);
//       }
//     }
//     lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
//   });
// });

function makeSlideshow(slides) {
  const sectionId = "{{ section.id }}";
  const sliderId = `GalleryViewer-${sectionId}`;
  const slider = document.getElementById(sliderId);

  const slider_inner = slider.querySelector("ul");
  const images = slider_inner.querySelectorAll("li");

  window.addEventListener("scroll", function (e) {
    e.preventDefault();
    // clear the interval
    // add a new interval
    nextSlide();
  });

  window.addEventListener("scroll", function (e) {
    e.preventDefault();
    // clear the interval
    // add a new interval
    prevSlide();
  });

  delay = 3000;
  transition = 400;

  slider_inner.style.transition = `${transition}ms`;

  const slidesWidth = slides.clientWidth;

  let index = 0;

  if (!isNaN(delay) && delay > 0) {
    setInterval(nextSlide, delay);
  }

  function nextSlide() {
    index += 1;
    if (index === images.length) {
      index = 0;
    }
    showSlide();
  }

  function prevSlide() {
    index -= 1;
    if (index < 0) {
      index = images.length - 1;
    }
    showSlide();
  }

  function showSlide() {
    // CSS - transform : translate3d(0, 0, 0);
    slider_inner.style.transform = `translate3d(0, ${
      index * -slidesWidth
    }px, 0)`;
    // console.log(index * -slidesWidth)
  }
}

// const slideshows = document.querySelectorAll(slider);

// for (let i = 0; i < slideshows.length; i += 1) {
//   makeSlideshow(slideshows[i]);
// }

function makeSlideshow(slider) {
  const sectionId = slider.dataset.sectionId;
  const sliderId = `GalleryViewer-${sectionId}`;
  const sliderInner = slider.querySelector("ul");
  const images = sliderInner.querySelectorAll("li");

  let index = 0;
  const delay = 3000; // delay between slides
  const transition = 400; // transition duration
  const slidesWidth = slider.clientWidth;

  sliderInner.style.transition = `${transition}ms`;

  let lastScrollTop = 0;

  function nextSlide() {
    index += 1;
    if (index === images.length) {
      index = 0;
    }
    showSlide();
  }

  function prevSlide() {
    index -= 1;
    if (index < 0) {
      index = images.length - 1;
    }
    showSlide();
  }

  function showSlide() {
    sliderInner.style.transform = `translate3d(0, ${
      index * -slidesWidth
    }px, 0)`;
  }

  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      // Scrolling down
      nextSlide();
    } else {
      // Scrolling up
      prevSlide();
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  });

  if (!isNaN(delay) && delay > 0) {
    setInterval(nextSlide, delay);
  }
}

// document.addEventListener("DOMContentLoaded", function () {
//   const slideshows = document.querySelectorAll(sliderId);
//   for (let i = 0; i < slideshows.length; i += 1) {
//     makeSlideshow(slider[i]);
//   }
// });

// const slideshows = document.querySelectorAll(slider)

// for (let i = 0; i < slideshows.length; i += 1) {
//     makeSlideshow(slideshows[i])


